import { HttpParams } from '@angular/common/http'
import { Component, computed, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    templateUrl: './barcode-manager.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class BarcodeManagerComponent extends BaseComponent {
    faSearch = faSearch
    grid: Grid<any>

    barcodes = signal<number[]>([])
    nextBarcode = computed(() => this.barcodes()[this.barcodes().length - 1] + 1)

    constructor() {
        super()

        this.grid = new Grid<any>(this.services)
            .wrapColumnHeaders()
            .filterBy(item => [item.barcode, item.manufacturer, item.material, item.model, item.retiredDate])

        this.refresh()
    }
    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('api/Barcode/GetBarcodes')).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    const items = result[0] as any[]
                    this.barcodes.set(items.map(x => +x.barcode))
                    this.grid.items = items
                },
            }),
        )
    }

    reserveNextBarcode() {
        const barcodeToSave = this.nextBarcode().toString()
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get('api/Barcode/ReserveNextBarcode', new HttpParams().set('nextBarcode', barcodeToSave)),
                )
                .subscribe({
                    next: () => {
                        this.barcodes.update(b => [...b, this.nextBarcode()])
                        this.grid.items.push({
                            barcode: barcodeToSave,
                            manufacturer: 'TBD',
                            material: 'TBD',
                            model: 'TBD',
                            retiredDate: null,
                        })
                        this.grid.refresh()
                        this.services.notification.success('Reserved barcode', `Barcode ${barcodeToSave} reserved`)
                    },
                    error: error => {
                        this.services.notification.error('Error reserving barcode', error)
                    },
                }),
        )
    }
}
